/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['aja', './template', './errorHandlerJsnop', './analytics'], function(aja, template, errorHandler, analytics) {
    'use strict';
    function callbackFunction(callback, fail) {
        return function(response) {
            if (!response.errorResponse) {
                callback(response);
                return;
            }
            if (fail) {
                fail(response.errorResponse['@description']);
            }
        };
    }

    function prepareOptions(options) {
        options.pathParameters = options.pathParameters || {};
        options.pathParameters.contentType = 'jsonp';
        options.pathParameters.protocol = options.pathParameters.protocol || 'https';
        options.callbackParam = options.callbackParam || 'jsonp';

    }

    function addQueryParams(options, req) {
        return options.queryParameters ? req.data(options.queryParameters) : req;
    }

    return {
        /**
         * Executes a request and processes the response as JSON.
         * @method get
         * @param {Object} options Specifies the details of the request.
         * @param {String} options.url The URL to request with {placeholders} for path parameters. {contentType}
         *     will be replaced accordingly.
         * @param {Object} [options.queryParameters] The data to pass as GET parameters with the request.
         * @param {Object} [options.pathParameters] The data to use as {placeholders} in url.
         * @param {Function} options.callback The callback to execute when the request completes.
         * @param {String} [options.callbackParam=jsonp] The parameter name that the endpoint expects to qualify
         *     the JSONP callback function.
         */
        get: function(options) {
            var url, req;
            console.warn('The support for JSONP will be removed soon. Please consider using the JSON implementation.');
            prepareOptions(options);
            url = template(options.url, options.pathParameters);
            req = aja().url(url).type('jsonp').jsonPaddingName(options.callbackParam);
            req = analytics.addAnalyticsHeader(req);
            req = addQueryParams(options, req);
            req = errorHandler(options, req);
            req.on('success', callbackFunction(options.callback, options.fail)).go();
        }
    };
});



// WEBPACK FOOTER //
// ./requester/jsonp.js